import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Accordion from "react-bootstrap/Accordion";
import OtherService from "../../services/Other";
import BigBox from "../BigBox";
import { formatNumber } from "../../constants/commonFunction";

const ReferralListComp = () => {
  const navigate = useNavigate();
  const [loadingst, setLoadingst] = useState(false);
  const [referList, setReferList] = useState([]);
  const brandId = JSON.parse(localStorage.getItem("currentBrand")).id;

  useEffect(() => {
    getList();
  }, [brandId]);

  const getList = async () => {
    setLoadingst(true);
    try {
      const res = await OtherService.referralList();
      setLoadingst(false);
      if (res.success) {
        let list = res.response;
        let updatedList = list.flatMap((group) =>
          group.referred_contacts.map((contact) => ({
            ...contact,
            referrer_code: group.referrer_code,
          }))
        );
        // if (type == 'comp') {
        //     updatedList = updatedList.slice(0, 3);
        // }
        setReferList(updatedList);
      } else {
        setReferList([]);
        const obj = res.response.error;
      }
    } catch (e) {
      setReferList([]);
      setLoadingst(false);
    }
  };

  const RenderItem = ({
    item,
    brandId,
    formatDateTime,
    ADANI_COLOR_PALATE,
  }) => {
    return (
      <div
        className="mb-4 w-full border border-[#E5E5E5] rounded bg-[#FAFAFA]"
        style={{
          boxShadow: "0px 1px 3px rgba(0,0,0,0.25)",
          borderLeft: `5px solid ${
            brandId === "2" ? ADANI_COLOR_PALATE[0] : ADANI_COLOR_PALATE[1]
          }`,
        }}
      >
        <div className="p-3">
          <div className="flex flex-row mb-1">
            <div className="flex-[1.5] pl-1">
              <p className="text-black text-sm font-normal leading-5">
                Contractor Name
              </p>
            </div>
            <div className="flex-[2]">
              <p className="text-[#555555] text-sm leading-5 font-normal mb-1">
                {item?.name}
              </p>
            </div>
          </div>

          <div className="flex flex-row mb-1">
            <div className="flex-[1.5] pl-1">
              <p className="text-black text-sm font-normal leading-5">
                Referral Code
              </p>
            </div>
            <div className="flex-[2]">
              <p className="text-[#555555] text-sm leading-5 font-normal mb-1">
                {item?.referrer_code}
              </p>
            </div>
          </div>

          <div className="flex flex-row mb-1">
            <div className="flex-[1.5] pl-1">
              <p className="text-black text-sm font-normal leading-5">
                Referred At
              </p>
            </div>
            <div className="flex-[2]">
              <p className="text-[#555555] text-sm leading-5 font-normal mb-1">
                {formatDateTime(item?.referred_at)}
              </p>
            </div>
          </div>

          <div className="flex flex-row">
            <div className="flex-[1.5] pl-1">
              <p className="text-black text-sm font-normal leading-5">
                Registered At
              </p>
            </div>
            <div className="flex-[2]">
              <p className="text-[#555555] text-sm leading-5 font-normal mb-1">
                {formatDateTime(item?.registered_at)}
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="recent-transactions-container" style={{ padding: "16px" }}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "12px",
        }}
      >
        <BigBox header="Recent Referrals" />
        <button
          style={{
            background: "none",
            border: "none",
            color: "#007bff",
            cursor: "pointer",
            textDecoration: "underline",
            fontSize: "14px",
          }}
          onClick={() => navigate("/referral-list")}
        >
          View All
        </button>
      </div>

      {loadingst ? (
        <p style={{ textAlign: "center", padding: "12px" }}>Loading...</p>
      ) : referList.length > 0 ? (
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))",
            gap: "16px",
          }}
        >
          {referList.slice(0, 3).map((item, index) => (
            <div
              key={index}
              style={{
                border: "1px solid #E5E5E5",
                borderRadius: "8px",
                background: "#FAFAFA",
                padding: "12px",
                boxShadow: "0px 1px 3px rgba(0,0,0,0.1)",
                height: "100%",
                width: "100%",
                textAlign: "left",
              }}
            >
              <p
                style={{ fontSize: "14px", color: "#000", marginBottom: "4px" }}
              >
                <strong>Contractor Name:</strong> {item?.name}
              </p>
              <p
                style={{ fontSize: "14px", color: "#555", marginBottom: "4px" }}
              >
                <strong>Referral Code:</strong> {item?.referrer_code}
              </p>
              <p
                style={{ fontSize: "14px", color: "#555", marginBottom: "4px" }}
              >
                <strong>Referred At:</strong>{" "}
                {item?.referred_at
                  ? new Date(item.referred_at).toLocaleString("en-IN", {
                      day: "2-digit",
                      month: "short",
                      year: "numeric",
                      hour: "numeric",
                      minute: "numeric",
                      hour12: true,
                    })
                  : "-"}
              </p>
              <p style={{ fontSize: "14px", color: "#555" }}>
                <strong>Registered At:</strong>{" "}
                {item?.registered_at
                  ? new Date(item.registered_at).toLocaleString("en-IN", {
                      day: "2-digit",
                      month: "short",
                      year: "numeric",
                      hour: "numeric",
                      minute: "numeric",
                      hour12: true,
                    })
                  : "-"}
              </p>
            </div>
          ))}
        </div>
      ) : (
        <p style={{ textAlign: "center", color: "#777" }}>
          No referrals found.
        </p>
      )}
    </div>
  );
};

export default ReferralListComp;
